/**
 * On a phone, gives the collection card nearest the middle of the screen the
 * same raised look a mouse hover gives it on desktop, and moves it along as the
 * page scrolls — Canna River's collection grid does the same. A touch screen has
 * no hover to show which card is in play, and the one it fakes sticks to
 * whatever was last tapped (nr-theme.css switches that sticky :hover off).
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-collection')) return;

  var ACTIVE = 'is-focused';
  // Matches the one-card-per-row breakpoint in nr-theme.css.
  var phone = window.matchMedia('(max-width: 47.9375rem) and (hover: none)');
  var current = null;
  var ticking = false;

  function setActive(card) {
    if (card === current) return;
    if (current) current.classList.remove(ACTIVE);
    if (card) card.classList.add(ACTIVE);
    current = card;
  }

  function update() {
    ticking = false;

    if (!phone.matches) {
      setActive(null);
      return;
    }

    // Queried fresh each frame: filtering and sorting swap the grid out wholesale.
    var cards = document.querySelectorAll('.ProductList--grid .ProductItem__Wrapper');
    // A little above centre, where the eye sits while thumbing down a list.
    var focusY = window.innerHeight * 0.42;
    var best = null;
    var bestDistance = Infinity;

    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight || rect.height < 1) continue;

      var distance = Math.abs(rect.top + rect.height / 2 - focusY);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = cards[i];
      }
    }

    setActive(best);
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  if (phone.addEventListener) phone.addEventListener('change', schedule);
  schedule();
})();
